module.exports = __webpack_public_path__ + "media/img/carQ_autoplac_baner-f5ed6016.png";